import axios from "./index.js"
import qs from "qs";

const DEFAULT_TABLE_COLUMNS = [
	{
		title: "License ID",
		dataIndex: "licenseId",
		key: "licenseId",
		width: 130,
		hiddenCol: true,
		itemIsChecked:true,
		slot: 'licenseId',
		scopedSlots: { customRender: 'licenseId' },
	},
	{
		title: "License 版本",
		dataIndex: "versionType",
		key: "versionType",
		width: 100,
		itemIsChecked: false,
	},
	{
		title: "项目名称",
		dataIndex: "projectName",
		key: "projectName",
		width: 208,
		itemIsChecked: true,
		slot: 'projectName',
		scopedSlots: { customRender: 'projectName' },
	},
	{
		title: "相关产品",
		dataIndex: "productTypes",
		key: "productTypes",
		width: 100,
		itemIsChecked: false,
		slot: 'productTypes',
		scopedSlots: { customRender: 'productTypes' },
		ellipsis: true
	},
	{
		title: "申请工单号",
		dataIndex: "orderNo",
		key: "orderNo",
		width: 200,
		itemIsChecked: true,
		slot:"orderNo",
		scopedSlots: { customRender: 'orderNo' },
		ellipsis: true
	},
	{
		title: "申请人",
		dataIndex: "applicantName",
		key: "applicantName",
		width: 130,
		itemIsChecked: true,
		slot:"applicantName",
		scopedSlots: { customRender: 'applicantName' },
	},
	{
		title: "最终客户",
		itemIsChecked: true,
		dataIndex: "customerName",
		key: "customerName",
		width: 200,
		slot:"customerName",
		scopedSlots: { customRender: 'customerName' },
	},
	{
		title: "申请时间",
		itemIsChecked: true,
		dataIndex: "applyTime",
		key: "applyTime",
		sortable: true,
		width: 144,
	},
	{
		title: "生成时间",
		itemIsChecked: true,
		dataIndex: "createTime",
		key: "createTime",
		width: 144,
		defaultSortOrder: 'descend',
		sorter: (a, b) => {
			let aTime = new Date(a.createTime).getTime();
			let bTime = new Date(b.createTime).getTime();
			return aTime - bTime;
		},
	},
	{
		title: "生效时间",
		itemIsChecked: false,
		dataIndex: "activeTime",
		key: "activeTime",
		sortable: true,
		width: 144,
		slot:"activeTime",
		scopedSlots: { customRender: 'activeTime' },
	},
	{
		title: "状态",
		itemIsChecked: true,
		dataIndex: "status",
		width: 68,
		key: "status",
	},
	{
		title: "操作",
		key: "action",
		fixed: "right",
		scopedSlots: { customRender: 'action' },
		slot: "action",
		itemIsChecked:true,
		align: "center",
		width: 200,
	}
]

const TABLE_COLUMNS_KEY = "manage_table_columns"

let manage_service = {
	query: (info) => {
		return axios({
			headers: {
				'Content-Type': 'application/json'
			},
			method: "post",
			url: "api/rest/mgmt/getList",
			data:info
		})
	},

	downloadByOrderNo:(info)=>{
		return  axios({
			method:"get",
			url:"/rest/mgmt/download",
			params:info
		})
	},

	// 查询自定义表头的数据
	queryCustomHeader:()=>{
		return new Promise((resolve, reject) =>{
			const columnsStr = sessionStorage.getItem(TABLE_COLUMNS_KEY)
			let columns = []
			if(!columnsStr){
				sessionStorage.setItem(TABLE_COLUMNS_KEY,JSON.stringify(DEFAULT_TABLE_COLUMNS.map(col=>{
					return {...col,id:col.key}
				})))
				columns = DEFAULT_TABLE_COLUMNS
			}else{
				columns = JSON.parse(columnsStr)
			}
			resolve({data:columns})
		})
	},

	// 更新自定义表头数据
	updateCustomHeader:(key,info)=>{
		return new Promise((resolve =>{
			let columnsStr = sessionStorage.getItem(TABLE_COLUMNS_KEY)
			const columns = JSON.parse(columnsStr)
			const updateColumn = columns.find(col=> col.key === key)
			updateColumn['itemIsChecked'] = info.itemIsChecked
			sessionStorage.setItem(TABLE_COLUMNS_KEY, JSON.stringify(columns))
		}))
	},
	// 发送邮件
	sendEmailByOrderNo(info){
		var CancelToken = axios.CancelToken
		var source = CancelToken.source()

		return  axios({
			headers: {
				'Content-Type': 'application/json'
			},
			method:"post",
			url:"rest/mgmt/sendMail",
			data:info,
			cancelToken: new axios.CancelToken(function executor(c) {
				that.source = c;
			})
		})
	}
}
export default manage_service;